<template>
  <div class="w-100">
    <div class="w-100 d-flex align-items-center my-2">
      <button class="btn btn-sm btn-primary" @click="toInsertProPage()">新增商品</button>
    </div>

    <div class="d-flex justify-content-between">
      <div>
        <b-card no-body header-class="text-center">
          <template v-slot:header>
            <span>商品排版設定</span>
          </template>

          <b-list-group>
            <b-list-group-item>
              <p class="mb-1 text-nowrap">一列顯示幾筆商品</p>

              <select class="form-control mb-1" v-model="proTempData.rowCount">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>

              <div class="d-flex align-items-center justify-content-between text-nowrap">
                <b-form-radio-group class="d-flex flex-column" v-model="proTempData.model">
                  <b-form-radio value="chessSort">棋盤排列 </b-form-radio>
                  <b-form-radio value="autoSort">自動排列 </b-form-radio>
                </b-form-radio-group>
                <a href="#">圖例</a>
              </div>
            </b-list-group-item>

            <b-list-group-item>
              <div class="w-100 d-flex align-items-center justify-content-between mb-1">
                <p class="m-0">排版模式</p>
                <a href="#">圖例</a>
              </div>

              <div class="w-100">
                <b-form-radio-group class="d-flex flex-column" v-model="proTempData.type">
                  <b-form-radio value="vertical_1">直式 1
                  </b-form-radio>

                  <b-form-radio value="vertical_2">直式 2
                  </b-form-radio>

                  <b-form-radio value="horizontal_1">橫式 1
                  </b-form-radio>

                  <b-form-radio value="horizontal_2">橫式 2
                  </b-form-radio>
                </b-form-radio-group>
              </div>

              <p class="mb-1 text-nowrap">縮圖比例</p>

              <b-form-input v-model="proTempData.image.percentage" type="range" min="50" max="150"
                step="1">
              </b-form-input>

              <div class="d-flex align-items-center justify-content-between">
                <b-form-input min="50" max="150" v-model="proTempData.image.percentage">
                </b-form-input>
                <small class="pl-2 text-primary">%</small>
              </div>

            </b-list-group-item>

            <b-list-group-item>
              <p class="mb-1">標示圖案</p>
              <div class="w-100 d-flex align-items-center justify-content-between mb-1">
                <span class="text-nowrap" style="width: 60px; min-width: 60px">顏色</span>
                <input type="color" class="form-control" v-model="proTempData.iconColor" />
              </div>
              <div class="w-100 d-flex align-items-center justify-content-between">
                <a href="#" style="width: 60px; min-width: 60px">選圖示</a>
                <font-awesome-icon :icon="['fas', 'star']" />
              </div>
            </b-list-group-item>

            <b-list-group-item>
              <p class="mb-1">商品名稱</p>
              <div class="w-100 mb-1">
                <span>字體大小</span>
                <div class="d-flex align-items-center justify-content-around">
                  <b-form-radio-group class="d-flex" v-model="proTempData.product.nameSize">
                    <b-form-radio value="15">
                      小
                    </b-form-radio>
                    <b-form-radio value="20">
                      中
                    </b-form-radio>
                    <b-form-radio value="25">
                      大
                    </b-form-radio>
                    <b-form-radio value="30">
                      巨
                    </b-form-radio>
                  </b-form-radio-group>
                </div>
              </div>

              <div class="w-100 d-flex align-items-center justify-content-between mb-1">
                <span class="text-nowrap" style="width: 60px; min-width: 60px">顏色</span>
                <b-form-input v-model="proTempData.product.nameColor" type="color"></b-form-input>
              </div>
            </b-list-group-item>

            <b-list-group-item>
              <p class="mb-1">商品內容</p>
              <div class="d-flex align-items-center justify-content-around mb-1">
                <b-form-radio-group class="d-flex" v-model="proTempData.product.contentSize">
                  <b-form-radio value="15">
                    小
                  </b-form-radio>
                  <b-form-radio value="20">
                    中
                  </b-form-radio>
                  <b-form-radio value="25">
                    大
                  </b-form-radio>
                  <b-form-radio value="30">
                    巨
                  </b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="w-100 d-flex align-items-center justify-content-between mb-1">
                <span class="text-nowrap" style="width: 60px; min-width: 60px">顏色</span>
                <b-form-input v-model="proTempData.product.contentColor" type="color">
                </b-form-input>
              </div>
            </b-list-group-item>

            <b-list-group-item>
              <p class="mb-1">價格設定</p>
              <div class="w-100 mb-1">
                <span class="w-100 mb-1">一般價格設定</span>
                <div class="w-100 d-flex align-items-center justify-content-between mb-1">
                  <span class="text-nowrap" style="width: 60px; min-width: 60px">顏色</span>
                  <b-form-input v-model="proTempData.product.priceColor" type="color">
                  </b-form-input>
                </div>
              </div>

              <div class="w-100 mb-1">
                <b-form-checkbox class="text-nowrap" switch
                  v-model="proTempData.product.showMemberPrice">
                  無會員是否能看到會員價
                </b-form-checkbox>
              </div>

              <div class="w-100 mb-1">
                <span class="w-100 mb-1">會員價格設定</span>
                <div class="w-100 d-flex align-items-center justify-content-between mb-1">
                  <span class="text-nowrap" style="width: 60px; min-width: 60px">顏色</span>
                  <b-form-input v-model="proTempData.product.memberPriceColor" type="color">
                  </b-form-input>
                </div>
              </div>

            </b-list-group-item>
          </b-list-group>
          <template v-slot:footer>
            <button class="btn btn-sm btn-primary" @click="saveProductModel()">儲存</button>
          </template>
        </b-card>
        <!-- <ul class="list-group">
          <li class="list-group-item">
            <span>《商品排版》</span>
          </li>
          <li class="list-group-item">
            <div class="d-flex flex-column">
              <div class="d-flex">
                <span class="flex-fill">每一橫列放幾件商品：</span>
                <div class="flex-fill">
                  <select v-model="temp.proSort" class="form-control">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="6">6</option>
                  </select>
                </div>
              </div>
              <div class="d-flex justify-content-around">
                <div>
                  <b-form-radio name="overviewRadio6" value="20">自動排列 </b-form-radio>
                </div>
                <div class="d-flex">
                  <b-form-radio name="overviewRadio6" value="20">棋盤排列 </b-form-radio>
                  <a href="#" @click.prevent>圖例</a>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex flex-column">
              <div class="d-flex">
                <div class="flex-fill">
                  <span>縮圖大小：</span>
                </div>
                <div class="flex-fill flex-column">
                  <span>{{ `${temp.proOverViewWidth}%（拖拉滑桿）` }}</span>
                  <b-form-input id="range-2" v-model="temp.proOverViewWidth" type="range" min="20"
                    max="100" step="1"></b-form-input>
                  <b-form-input type="number" min="100" max="500"
                        v-model="temp.proOverViewWidth">
                      </b-form-input>
                  <div class="d-flex justify-content-around">
                    <div>
                      <b-form-radio v-model="temp.proImgBorder" name="overviewRadio5" :value="true">
                        有圖框
                      </b-form-radio>
                    </div>
                    <div>
                      <b-form-radio v-model="temp.proImgBorder" name="overviewRadio5"
                        :value="false">
                        無圖框
                      </b-form-radio>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="d-flex flex-fill">
                  <span>排版</span>
                  <a href="#" @click.prevent>圖例</a>
                </div>
                <div class="d-flex justify-content-around">
                  <div>
                    <b-form-radio v-model="proTempData.type" name="overviewRadio7"
                      value="vertical_1">直1
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="proTempData.type" name="overviewRadio7"
                      value="vertical_2">直2
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="proTempData.type" name="overviewRadio7"
                      value="horizontal_1">橫1
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="proTempData.type" name="overviewRadio7"
                      value="horizontal_2">橫2
                    </b-form-radio>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex align-items-center">
              <span>小圖示</span>
              <div>
                <font-awesome-icon :icon="['fas', 'star']" style="color:darkgoldenrod;" />
              </div>
              <a href="#" @click.prevent>選圖示</a>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex flex-column">
              <span>商品名稱：</span>
              <div class="d-flex">
                <span>字大小</span>
                <div class="d-flex flex-fill justify-content-around">
                  <div>
                    <b-form-radio v-model="temp.proTitleSize" name="overviewRadio" value="20">小
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proTitleSize" name="overviewRadio" value="30">中
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proTitleSize" name="overviewRadio" value="40">大
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proTitleSize" name="overviewRadio" value="50">巨
                    </b-form-radio>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-fill align-items-center">
                <span>字顏色</span>
                <div class="flex-fill">
                  <b-form-input v-model="temp.proTitleColor" type="color"></b-form-input>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex flex-column">
              <span>價格：</span>
              <div class="d-flex">
                <span>字大小</span>
                <div class="d-flex flex-fill justify-content-around">
                  <div>
                    <b-form-radio v-model="temp.proPriceSize" name="overviewRadio2" value="15">小
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proPriceSize" name="overviewRadio2" value="20">中
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proPriceSize" name="overviewRadio2" value="25">大
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proPriceSize" name="overviewRadio2" value="30">巨
                    </b-form-radio>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-fill align-items-center">
                <span>字顏色</span>
                <div class="flex-fill">
                  <b-form-input v-model="temp.proPriceColor" type="color"></b-form-input>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex flex-column">
              <span>一般價會員價：</span>
              <div class="d-flex">
                <span>字大小</span>
                <div class="d-flex flex-fill justify-content-around">
                  <div>
                    <b-form-radio v-model="temp.proTypePriceSize" name="overviewRadio3" value="15">小
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proTypePriceSize" name="overviewRadio3" value="20">中
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proTypePriceSize" name="overviewRadio3" value="25">大
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proTypePriceSize" name="overviewRadio3" value="30">巨
                    </b-form-radio>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-fill align-items-center">
                <span>字顏色</span>
                <div class="flex-fill">
                  <b-form-input v-model="temp.proTypePriceColor" type="color"></b-form-input>
                </div>
              </div>
              <div class="d-flex flex-column">
                <span>當無權限時：</span>
                <div>
                  <b-form-radio name="overviewRadio2" value="20">使用？顯示金額 </b-form-radio>
                </div>
                <div>
                  <b-form-radio name="overviewRadio2" value="20">不顯示金額 </b-form-radio>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex flex-column">
              <span>商品簡要說明：</span>
              <div class="d-flex">
                <span>字大小</span>
                <div class="d-flex flex-fill justify-content-around">
                  <div>
                    <b-form-radio v-model="temp.proInfoSize" name="overviewRadio4" value="15">小
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proInfoSize" name="overviewRadio4" value="20">中
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proInfoSize" name="overviewRadio4" value="25">大
                    </b-form-radio>
                  </div>
                  <div>
                    <b-form-radio v-model="temp.proInfoSize" name="overviewRadio4" value="30">巨
                    </b-form-radio>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-fill align-items-center">
                <span>字顏色</span>
                <div class="flex-fill">
                  <b-form-input v-model="temp.proInfoColor" type="color"></b-form-input>
                </div>
              </div>
            </div>
          </li>
          <li class="list-group-item">
            <div class="d-flex justify-content-around">
              <button type="button" class="btn btn-outline-secondary" :disabled="noChange()"
                @click="cancelStyle()">
                取消
              </button>
              <button type="button" class="btn btn-outline-secondary" :disabled="noChange()"
                @click="saveStyle()">
                儲存
              </button>
            </div>
          </li>
        </ul> -->
      </div>

      <div class="flex-fill row no-gutters">
        <div class="pl-4 mb-2 list-group" v-for="index in 10" :key="'column__' + index"
          :class="getRowCount()">
          <div class="d-flex align-items-start py-2 px-1 shadow-sm list-group-item"
            v-if="proTempData.type == 'horizontal_1'">
            <div class="text-center overflow-hidden py-2 ml-2"
              style="width: 200px; min-width: 55px;">
              <a>
                <img
                  src="https://www.magee.tw/newErp/data/COM17051000010/WebClassPro/KxZ5ZrZ9mZySk5WlJCq9Vz2LSjYfDTUprBI0y2P6.jpeg"
                  alt="領隊導遊三科證照班"
                  style="min-width: 100%; min-height: 100%; max-width: 100%; max-height: 100%;">
              </a>
            </div>
            <div class="flex-fill px-0 mr-0">
              <div class="d-flex align-self-center">
                <div class="flex-column text-center m-2">
                  <div style="width:5em">time</div>
                </div>
                <div class="flex-fill flex-column align-self-center py-2 ml-2">
                  <div class="w-100">
                    <span class="text-dark">小標題</span>
                    <h3 class="mb-0 letter-s-1 font-weight-bold"
                      :style="{'font-size': proTempData.product.nameSize + 'px', 'color': proTempData.product.nameColor}">
                      <span :style="'color:' + proTempData.iconColor">
                        <font-awesome-icon :icon="['fas', 'star']" size="xs" />
                      </span>
                      大標題
                    </h3>
                    <div class="w-100 text-dark mt-3"
                      :style="{'font-size': proTempData.product.contentSize + 'px', 'color': proTempData.product.contentColor}">
                      商品內容<br>
                      商品內容<br>
                      商品內容<br>
                      商品內容
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100">
                <hr class="border-top ml-2 mr-1 mb-1 mt-0">
                <div class="d-flex font-weight-normal mx-1 mb-1 pt-0">
                  <div class="flex-fill d-flex align-self-stretch pl-1">
                    <div class="pr-3 m-0 align-self-strat align-self-end">
                      <div class="mb-1">
                        <span
                          class="font-up-0 text-center border rounded text-nowrap px-1 mt-1 ml-1 d-inline-block text-mblue border-mblue"
                          v-for="tag in 4" :key="'tag__'+tag">
                          + 標籤 {{tag}}
                        </span>
                      </div>
                      <div class="w-100">
                        <span class="text-dark ml-1">
                          備註說明
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-self-end ml-auto">
                    <div>
                      <div class="w-100 pt-1 pl-0">
                        <div class="d-flex align-items-end justify-content-end">
                          <div class="text-right">
                            <div class="text-muted mb-1">
                              <small class="text-right">
                                <s>NT$ 10,000</s>
                              </small>
                            </div>
                            <div>
                              <a class="cur-print text-nowrap" href="#"
                                :style="{'color': proTempData.product.priceColor}">NT
                                <span class="font-up-5 ml-1">$ 4,800</span></a>
                            </div>
                          </div>
                          <div class="ml-2 d-flex align-items-center">
                            <a href="#" class="btn rounded-circle text-center btn-deepgold"
                              style="width: 35px; height: 35px;">
                              <div class="clearfix">
                                <font-awesome-icon :icon="['fas', 'chevron-right']" size="lg" />
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <b-card no-body align="center" tag="div" class="m-2 align-items-center flex-fill">
              
              <template v-if="proTempData.type === 'vertical_1'">
                <div class="d-flex flex-column align-items-center">
                  <div class="d-flex flex-fill align-items-center justify-content-center">
                    <div :style="{
                          width: `${temp.proOverViewWidth}%`,
                          height: `${temp.proOverViewWidth}%`
                        }" :class="{ 'p-2': temp.proImgBorder, border: temp.proImgBorder }">
                      <b-card-img src="https://picsum.photos/400/400/?image=25" alt="商品圖">
                      </b-card-img>
                    </div>
                  </div>
                  <b-card-title :style="{
                        'font-size': temp.proTitleSize + 'px',
                        color: temp.proTitleColor
                      }">
                    <font-awesome-icon :icon="['fas', 'star']" style="color:darkgoldenrod;" />
                    商品名
                  </b-card-title>
                  <span :style="{
                        'font-size': temp.proInfoSize + 'px',
                        color: temp.proInfoColor
                      }">這是商品簡介</span>
                  <div class="d-flex align-items-center">
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proTypePriceSize + 'px',
                            color: temp.proTypePriceColor
                          }">一般價：</b-card-text>
                    </div>
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proPriceSize + 'px',
                            color: temp.proPriceColor
                          }">
                        100000
                      </b-card-text>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proTypePriceSize + 'px',
                            color: temp.proTypePriceColor
                          }">會員價：</b-card-text>
                    </div>
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proPriceSize + 'px',
                            color: temp.proPriceColor
                          }">
                        99999
                      </b-card-text>
                    </div>
                  </div>
                  <b-button href="#" variant="primary" @click="test()">訂購</b-button>
                </div>
              </template>

              <template v-else-if="proTempData.type === 'vertical_2'">
                <div class="d-flex flex-column align-items-center">
                  <div class="d-flex flex-fill align-items-center justify-content-center order-2">
                    <div :style="{
                          width: `${temp.proOverViewWidth}%`,
                          height: `${temp.proOverViewWidth}%`
                        }" :class="{ 'p-2': temp.proImgBorder, border: temp.proImgBorder }">
                      <b-card-img src="https://picsum.photos/400/400/?image=25" alt="商品圖">
                      </b-card-img>
                    </div>
                  </div>
                  <b-card-title class="order-1" :style="{
                        'font-size': temp.proTitleSize + 'px',
                        color: temp.proTitleColor
                      }">
                    <font-awesome-icon :icon="['fas', 'star']" style="color:darkgoldenrod;" />
                    商品名
                  </b-card-title>
                  <span class="order-3" :style="{
                        'font-size': temp.proInfoSize + 'px',
                        color: temp.proInfoColor
                      }">這是商品簡介</span>
                  <div class="d-flex align-items-center order-4">
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proTypePriceSize + 'px',
                            color: temp.proTypePriceColor
                          }">一般價：</b-card-text>
                    </div>
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proPriceSize + 'px',
                            color: temp.proPriceColor
                          }">
                        100000
                      </b-card-text>
                    </div>
                  </div>
                  <div class="d-flex align-items-center order-5">
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proTypePriceSize + 'px',
                            color: temp.proTypePriceColor
                          }">會員價：</b-card-text>
                    </div>
                    <div>
                      <b-card-text :style="{
                            'font-size': temp.proPriceSize + 'px',
                            color: temp.proPriceColor
                          }">
                        99999
                      </b-card-text>
                    </div>
                  </div>
                  <b-button class="order-6" href="#" variant="primary" @click="test()">訂購
                  </b-button>
                </div>
              </template>

              <template v-else-if="proTempData.type == 'horizontal_1'">
                <div class="d-flex justify-content-around align-items-center">
                  <div class="d-flex w-100 align-items-center justify-content-center">
                    <div :style="{
                          width: `${temp.proOverViewWidth}%`,
                          height: `${temp.proOverViewWidth}%`
                        }" :class="{ 'p-2': temp.proImgBorder, border: temp.proImgBorder }">
                      <b-card-img src="https://picsum.photos/400/400/?image=25" alt="商品圖">
                      </b-card-img>
                    </div>
                  </div>
                  <div class="d-flex w-100 flex-column align-items-center">
                    <b-card-title :style="{
                          'font-size': temp.proTitleSize + 'px',
                          color: temp.proTitleColor
                        }">
                      <font-awesome-icon :icon="['fas', 'star']" style="color:darkgoldenrod;" />
                      商品名
                    </b-card-title>
                    <span :style="{
                          'font-size': temp.proInfoSize + 'px',
                          color: temp.proInfoColor
                        }">這是商品簡介</span>
                    <div class="d-flex align-items-center">
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proTypePriceSize + 'px',
                              color: temp.proTypePriceColor
                            }">一般價：</b-card-text>
                      </div>
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proPriceSize + 'px',
                              color: temp.proPriceColor
                            }">
                          100000
                        </b-card-text>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proTypePriceSize + 'px',
                              color: temp.proTypePriceColor
                            }">會員價：</b-card-text>
                      </div>
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proPriceSize + 'px',
                              color: temp.proPriceColor
                            }">
                          99999
                        </b-card-text>
                      </div>
                    </div>
                    <b-button href="#" variant="primary" @click="test()">訂購</b-button>
                  </div>
                </div>
              </template>
              <template v-else-if="proTempData.type === 'horizontal_2'">
                <div class="d-flex justify-content-around align-items-center">
                  <div class="d-flex flex-column w-100 align-items-center justify-content-center">
                    <b-card-title :style="{
                          'font-size': temp.proTitleSize + 'px',
                          color: temp.proTitleColor
                        }">
                      <font-awesome-icon :icon="['fas', 'star']" style="color:darkgoldenrod;" />
                      商品名
                    </b-card-title>
                    <div :style="{
                          width: `${temp.proOverViewWidth}%`,
                          height: `${temp.proOverViewWidth}%`
                        }" :class="{ 'p-2': temp.proImgBorder, border: temp.proImgBorder }">
                      <b-card-img src="https://picsum.photos/400/400/?image=25" alt="商品圖">
                      </b-card-img>
                    </div>
                  </div>
                  <div class="d-flex w-100 flex-column align-items-center">
                    <span :style="{
                          'font-size': temp.proInfoSize + 'px',
                          color: temp.proInfoColor
                        }">這是商品簡介</span>
                    <div class="d-flex align-items-center">
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proTypePriceSize + 'px',
                              color: temp.proTypePriceColor
                            }">一般價：</b-card-text>
                      </div>
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proPriceSize + 'px',
                              color: temp.proPriceColor
                            }">
                          100000
                        </b-card-text>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proTypePriceSize + 'px',
                              color: temp.proTypePriceColor
                            }">會員價：</b-card-text>
                      </div>
                      <div>
                        <b-card-text :style="{
                              'font-size': temp.proPriceSize + 'px',
                              color: temp.proPriceColor
                            }">
                          99999
                        </b-card-text>
                      </div>
                    </div>
                    <b-button href="#" variant="primary" @click="test()">訂購</b-button>
                  </div>
                </div>
              </template>
            </b-card> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import ctrl from "@/js/proManage/proOverview.js";
  export default ctrl;

</script>

<style lang="scss"></style>
